import React, { forwardRef } from 'react';
import type { Questionnaire, QuestionnaireOverrides, Answer, Error, RenderTextArgs, RenderQuestionTopContentArgs, RenderQuestionBottomContentArgs, QuestionnaireHandle, ProcessFileOnDrop } from '../types';
import { QuestionnaireProvider } from '../contexts/questionnaire-context';
import Questions from './questions';
type Props = {
  questionnaire: Questionnaire;
  questionnaireAnswers: Answer[];
  errors?: Error[];
  overrides?: QuestionnaireOverrides;
  onQuestionAnswered?: (answerMap: Map<string, Answer>, questionId: string, answers: string[]) => void;
  onAnswerStateChanged?: (answerMap: Map<string, Answer>) => void;
  renderText?: (args: RenderTextArgs) => React.ReactNode | null;
  renderQuestionTopContent?: (args: RenderQuestionTopContentArgs) => React.ReactNode | null;
  renderQuestionBottomContent?: (args: RenderQuestionBottomContentArgs) => React.ReactNode | null;
  processFileOnDrop?: ProcessFileOnDrop;
};
const Root = forwardRef<QuestionnaireHandle, Props>(function Root({
  questionnaire,
  questionnaireAnswers,
  overrides = {},
  errors = [],
  onQuestionAnswered = () => {},
  onAnswerStateChanged = () => {},
  renderText = () => null,
  renderQuestionTopContent = () => null,
  renderQuestionBottomContent = () => null,
  processFileOnDrop
}, ref): React.ReactElement {
  return <QuestionnaireProvider questionnaire={questionnaire} questionnaireAnswers={questionnaireAnswers} overrides={overrides} errors={errors} onQuestionAnswered={onQuestionAnswered} onAnswerStateChanged={onAnswerStateChanged} renderText={renderText} renderQuestionTopContent={renderQuestionTopContent} renderQuestionBottomContent={renderQuestionBottomContent} questionnaireRef={ref} processFileOnDrop={processFileOnDrop}>
      <Questions questionIds={questionnaire.topQuestionIdList} />
    </QuestionnaireProvider>;
});
export default Root;